<template>
    <div class="py-5 px-10">
        <div class="symbol symbol-45px symbol-circle me-5 d-flex">
            <img src="/images/defaultzada.png" alt="">
            <div class="d-flex flex-column flex-row-fluid justify-content-evenly">
                <div class="text-gray-800 fw-bold me-6">{{ props.content.first_name.toUpperCase() }}</div>
            </div>
            <div>
                <button v-if="props.content.isAdmin || props.content.postUser" class="btn-filtro btn btn-sm fw-bold px-4" style="width: 100%;" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fas fa-ellipsis-v"></i>
                    <ul class="dropdown-menu">
                        <li>
                            <button class="dropdown-item" @click="deletePost(props.content.contentId)">
                                <i class="fas fa-trash-alt text-danger"></i>
                                &nbsp;&nbsp;Deletar post
                            </button>
                        </li>
                    </ul>
                </button>
            </div>
        </div>
    </div>
    <div class="px-10 row">
        <span class="text-gray-800 fs-7 fw-normal pt-1">
            {{ props.content.content }}
        </span>
    </div>
    <div v-if="!props.content.contentAllowed">
        <button v-if="!props.content.isAdmin" class="btn btn-sm btn-full btn-primary fw-bold px-4" style="width: 100%;">
            <i class="far fa-clock"></i>
            Aguardando moderação
        </button>
        <button v-if="props.content.isAdmin && !props.content.contentAllowed" class="btn-filtro btn btn-sm btn-full btn-success fw-bold px-4" @click="allowPost(props.content.contentId)" style="width: 100%;">
            <i class="fas fa-check"></i>
            Autorizar postagem
        </button>
    </div>

</template>
<script lang="ts" setup>
import axios from 'axios';
import { router } from '@inertiajs/vue3';
import { errors } from '../../stores/errors'


export type Forum = {
    first_name: string,
    content: string,
    isAdmin: boolean,
    contentAllowed: boolean,
    contentId: string,
    postUser: boolean,
}

const show_erros = errors();


const props = defineProps({
    content: { type: Object as () => Forum, required: true },
    urlAllowPost: { type: String, required: true },
    urlToDeletePost: { type: String, required: true }
});


function allowPost(id: string) {
    show_erros.delete_messages();

    axios.post(
        props.urlAllowPost,
        {
            content: id
        }
    ).then(function (res) {
        router.reload({
            only: ['forum_contents'],
        });
        show_erros.set_has_errors(false);

    }).catch(function (err) {
        console.log(err);
        show_erros.set_has_errors(true);
        show_erros.set_messages(err.response.data.message);
    });
}

function deletePost(id: string) {
    show_erros.delete_messages();

    axios.delete(`${id}`)
        .then(function (res) {
            router.reload({
                only: ['forum_contents'],
            });
            show_erros.set_has_errors(false);
        }).catch(function (err) {
            show_erros.set_has_errors(true);
            show_erros.set_messages(err.response.data.message);
        });
}
</script>
